import React from 'react';
import "../styles/DPM.css";
import { useEffect } from "react";

const caseStudies = [
  {
    title: "Health Aid: A Digital Solution for Chronic Disease Management",
    content: [
      {
        heading: "Introduction",
        text: "Many individuals with chronic conditions struggle with managing symptoms, medication adherence, and tracking their health progress. Health Aid is a digital health platform designed to help users take control of their health through AI-driven symptom tracking, reminders, and interactive health tools.",
      },
      {
        heading: "Research & User Pain Points",
        text: "Identified pain points include forgetting medications, no easy way to log symptoms, lack of awareness about drug interactions, and the need for a simple health management tool.",
      },
      {
        heading: "Product Solution & Features",
        text: "Features include a symptom tracker, AI-powered symptom checker, first aid guide, drug interaction checker, inventory & pill reminders, and a health dashboard.",
      },
      {
        heading: "Expected Impact & Future Goals",
        text: "Short-term goals include launching an MVP, collecting feedback, and testing AI-powered features. Long-term vision involves wearable integrations, partnerships, and funding.",
      },
    ],
  },
  {
  
  title : "ClinicSphere: An Electronic Health Record System for Small Clinics",
  content: [
    {
      heading: "Introduction",
      text: "ClinicSphere is a modern electronic health record (EHR) system designed for small clinics to efficiently manage patient records, appointments, billing, and prescriptions. With an integrated patient portal, the platform enhances accessibility to medical records while optimizing clinic operations and improving patient care.",
    },
    {
      heading: "Research & User Pain Points",
      text: "Many small clinics struggle with outdated paper-based records, inefficient appointment scheduling, billing inaccuracies, and cumbersome prescription management. Administrative staff are overwhelmed with manual tasks, limiting the time they can dedicate to patient care. Additionally, patients, especially those in rural areas, often face difficulties in accessing their medical history.",
    },
    {
      heading: "Product Solution & Features",
      text: "ClinicSphere offers a range of essential features, including patient profile management, seamless appointment scheduling, automated billing and invoicing, efficient prescription handling, lab result integration, and comprehensive reporting tools. Additionally, the system empowers patients by providing secure access to their medical records.",
    },
    {
      heading: "Expected Impact & Future Goals",
      text: "By automating administrative workflows, ClinicSphere minimizes operational inefficiencies, enhances patient outcomes, and streamlines clinic management. Future enhancements include telemedicine integration and advanced data analytics to further improve patient care and decision-making.",
    },

  ],
},
]


const DigitalHealthProductManagement = () => {
  useEffect(() => {
    const container = document.querySelector(".DPM");
    if (container) {
      console.log("Scroll Height:", container.scrollHeight);
      console.log("Client Height:", container.clientHeight);
      console.log("Can Scroll?", container.scrollHeight > container.clientHeight);
      
      container.scrollTop = 0; // Scroll to top on load
    }
  }, []);
  
  
  return (
    <div className="DPM-container">
      <h1 className="title">Case Studies</h1>
      <div className="DPM">
        {caseStudies.map((study, index) => (
          <div key={index} className="casestudy-card">
            <div className="casestudy-content">
               <h2>{study.title}</h2>
              {study.content.map((section, idx) => (
                <div key={idx} className="casestudy-section">
                  <h3>{section.heading}</h3>
                  <p>{section.text}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DigitalHealthProductManagement;
